"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = require("./Utils");
class NumberUtils {
    static toHex(number) {
        const radix = 16;
        const basePart = typeof number === 'number'
            ? number.toString(radix)
            : `${number.toString(radix)}n`;
        return `${Utils_1.Utils.hexadecimalPrefix}${basePart}`;
    }
    static isCeil(number) {
        return typeof number === 'number'
            ? number % 1 === 0
            : true;
    }
}
exports.NumberUtils = NumberUtils;
